import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { useGameContext } from "../../../game/GameContext/GameContext";
import Label from "../../../ui/Label/Label";
import Input from "../../../ui/Input/Input";
import Button from "../../../ui/Button/Button";
import Slider from "../../../ui/Slider/Slider";
import BetAmountButtons from "./BetAmount.buttons";
import BetAmountCurrency from "./BetAmount.currency";
import { SliderWrapper } from "./BetAmount.styled";
import BetPicker from "./Betamount.picker";
import { InputWithLabelContainer } from "../../../game/GameContainer/GameContainer.styled";
var BetAmount = function () {
    var _a = useGameContext(), betAmount = _a.betAmount, setBetAmount = _a.setBetAmount, minBet = _a.minBet, maxBet = _a.maxBet, inProgress = _a.inProgress, autoPlayInProgress = _a.autoPlayInProgress, controlPanelDisabled = _a.controlPanelDisabled;
    var _b = useState(false), isSliderVisible = _b[0], setIsSliderVisible = _b[1];
    var _c = useState(null), sliderPosition = _c[0], setSliderPosition = _c[1];
    var _d = useState(betAmount.toString()), localBetAmount = _d[0], setLocalBetAmount = _d[1];
    var inputRef = useRef(null);
    var sliderRef = useRef(null);
    var toggleSlider = function () {
        setIsSliderVisible(function (prev) { return !prev; });
    };
    var isDisabled = useMemo(function () { return inProgress || autoPlayInProgress || controlPanelDisabled; }, [inProgress, autoPlayInProgress, controlPanelDisabled]);
    useEffect(function () {
        setLocalBetAmount(betAmount.toString());
    }, [betAmount]);
    useEffect(function () {
        if (inputRef.current) {
            var rect = inputRef.current.getBoundingClientRect();
            setSliderPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
            });
        }
    }, [isSliderVisible]);
    // hide slider on outside click
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (sliderRef.current &&
                !sliderRef.current.contains(event.target) &&
                inputRef.current &&
                !inputRef.current.contains(event.target)) {
                setIsSliderVisible(false);
            }
        };
        if (isSliderVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isSliderVisible]);
    var getFixedLocalBetAmountValue = function (value) {
        // Normalize decimal separator and parse value
        var normalizedValue = value.replace(",", ".");
        var parsedValue = parseFloat(normalizedValue);
        // Handle invalid or out-of-range values
        if (isNaN(parsedValue))
            return "0";
        if (parsedValue < minBet)
            return minBet.toString();
        if (parsedValue > maxBet)
            return maxBet.toString();
        // Split into integer and decimal parts
        var _a = normalizedValue.split("."), intPart = _a[0], decimalPart = _a[1];
        // Return integer part if no decimal
        if (!(decimalPart === null || decimalPart === void 0 ? void 0 : decimalPart.length))
            return intPart;
        // Format decimal part: keep max 2 digits and remove trailing zeros
        var formattedDecimal = decimalPart
            .substring(0, 2)
            .replace(/0+$/, "");
        // Return formatted number
        return formattedDecimal.length > 0
            ? "".concat(intPart, ".").concat(formattedDecimal)
            : intPart;
    };
    var updateBetAmount = function (event) {
        var value = getFixedLocalBetAmountValue(event.target.value);
        setLocalBetAmount(value);
        setBetAmount(parseFloat(value));
    };
    var updateLocalBetAmount = function (event) {
        setLocalBetAmount(event.target.value);
    };
    var updateSliderBetAmount = function (event) {
        setLocalBetAmount(event.target.value);
        setBetAmount(parseFloat(event.target.value));
    };
    var prepareStep = function () {
        if (parseFloat(localBetAmount) <= 10)
            return 1;
        if (parseFloat(localBetAmount) <= 100)
            return 5;
        return 10;
    };
    return (_jsxs(InputWithLabelContainer, { children: [_jsx(Label, { children: "Bet Amount" }), _jsx(Input, { ref: inputRef, disabled: isDisabled, type: "number", step: 0.01, min: minBet, max: maxBet, variant: "default", value: localBetAmount, onBlur: updateBetAmount, onChange: updateLocalBetAmount, placeholder: "10", leftContent: _jsx(BetAmountCurrency, {}), rightContent: _jsx(BetAmountButtons, { toggleSlider: toggleSlider }) }), _jsx(BetPicker, {}), isSliderVisible && sliderPosition && (_jsxs(SliderWrapper, { sliderPosition: sliderPosition, ref: sliderRef, children: [_jsx(Button, { disabled: isDisabled, onClick: function () { return setBetAmount(minBet); }, children: "Min" }), _jsx(Slider, { min: minBet, max: maxBet, step: prepareStep(), value: parseFloat(localBetAmount), disabled: isDisabled, onChange: updateSliderBetAmount }), _jsx(Button, { disabled: isDisabled, onClick: function () { return setBetAmount(maxBet); }, children: "Max" })] }))] }));
};
BetAmount.displayName = "BetAmount";
export default BetAmount;
//# sourceMappingURL=BetAmount.js.map